import initDatabase from './reducers'

const data = (state = initDatabase, action) => {
  switch (action.type) {
    case "FETCH_DATABASE_SUCCESS":
      return({
        ...state,
        data: action.payload,
        isLoaded: true
      })
    default:
      return state
  }
}

export default data